import { apiRequest } from './client'

export type ChatThreadSummary = {
  counterpartyOrgId: number
  counterpartyName: string
  lastMessageId: number | null
  lastMessagePreview: string | null
  lastMessageAt: string | null
  lastMessageFromMe: boolean
  unreadCount: number
}

// Терпимость к обоим написаниям на проводе: API нормализуется к snake_case,
// поэтому читаем camelCase, а при его отсутствии — snake_case.
type ChatThreadSummaryRaw = ChatThreadSummary & {
  counterparty_org_id?: number
  counterparty_name?: string
  last_message_id?: number | null
  last_message_preview?: string | null
  last_message_at?: string | null
  last_message_from_me?: boolean
  unread_count?: number
}

type PartnerThreadsResponse = {
  items: ChatThreadSummaryRaw[]
}

const normalizeThread = (raw: ChatThreadSummaryRaw): ChatThreadSummary => ({
  counterpartyOrgId: raw.counterpartyOrgId ?? raw.counterparty_org_id ?? 0,
  counterpartyName: raw.counterpartyName ?? raw.counterparty_name ?? '',
  lastMessageId: raw.lastMessageId ?? raw.last_message_id ?? null,
  lastMessagePreview: raw.lastMessagePreview ?? raw.last_message_preview ?? null,
  lastMessageAt: raw.lastMessageAt ?? raw.last_message_at ?? null,
  lastMessageFromMe: raw.lastMessageFromMe ?? raw.last_message_from_me ?? false,
  unreadCount: raw.unreadCount ?? raw.unread_count ?? 0,
})

export const listPartnerThreads = (organizationId: number) =>
  apiRequest<PartnerThreadsResponse>(`/organizations/${organizationId}/partner-threads`).then(
    (response) => (response.items ?? []).map(normalizeThread),
  )

export const markThreadRead = (
  organizationId: number,
  counterpartyOrganizationId: number,
  lastReadMessageId?: number,
) =>
  apiRequest<void>(
    `/organizations/${organizationId}/partner-threads/${counterpartyOrganizationId}/read`,
    {
      method: 'POST',
      body: lastReadMessageId != null ? { last_read_message_id: lastReadMessageId } : {},
    },
  )
